module.exports = __webpack_public_path__ + "img/Mask group.8ba0e56a.png";